<div class="mt-12 pivot-container">
  <div class="pivot-wrapper" style="zoom: 1.07;min-width: 400px; min-height: 148px;width:100%;overflow: auto;" id="pivottable">
  </div>
</div>
